import { render, staticRenderFns } from "./IntentForm.vue?vue&type=template&id=bd3ed6f0&scoped=true"
import script from "./IntentForm.vue?vue&type=script&lang=js"
export * from "./IntentForm.vue?vue&type=script&lang=js"
import style0 from "./IntentForm.vue?vue&type=style&index=0&id=bd3ed6f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd3ed6f0",
  null
  
)

export default component.exports